interface AffixTextProps {
  className?: string;
  text: string;
}

export const AffixText = ({ text, className }: AffixTextProps) => (
  <span className={className}>{text}</span>
);
